import { render, staticRenderFns } from "./tan_needGz_portrait.vue?vue&type=template&id=4fed7d69&scoped=true"
import script from "./tan_needGz_portrait.vue?vue&type=script&lang=js"
export * from "./tan_needGz_portrait.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_portrait.vue?vue&type=style&index=0&id=4fed7d69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed7d69",
  null
  
)

export default component.exports